import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import Card, { CardContent, CardActions } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'

import withAppStore from 'decorators/withAppStore'

import styles from 'styles/pages/auth/confirm/error'

@withStyles(styles)
@withAppStore
@observer
export default class extends Component {

  componentWillMount() {
    this.appStore.pageTitle = 'Подтверждение адреса электронной почты'
  }

  render() {
    const { classes } = this.props

    return (
      <Card elevation={1} className={ classes.card } >
        <CardContent>
          <Typography color='error' type='subheading' >
            При попытке подтвердить адрес электронной почты произошла ошибка. Попробуйте еще раз.
          </Typography>
        </CardContent>
        <CardActions>
          <Button fullWidth href='/#/auth?registration' >
            Перейти к регистрации
          </Button>
        </CardActions>
      </Card>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/confirm/error.js